import { Action, createReducer, on } from '@ngrx/store'
import { InitializeState, initialInitializeState } from '../state/initial.state'
import {
  clear_initialize_data,
  initialize_success,
  save_selected_companies,
  update_password_auto_generated
} from '../action/initialize.action'

export function initializeReducer(state: InitializeState, action: Action) {
  return _initializeReducer(state, action)
}

const _initializeReducer = createReducer(
  initialInitializeState,
  on(initialize_success, (state, data) => {
    return {
      ...state,
      taskTypes: data.initializeData.taskTypes as any,
      user: data.initializeData.user,
      selectedCompanies: data.initializeData.selectedCompanies,
      relatedCompanies: data.initializeData.relatedCompanies,
      uiStatusMapping: data.initializeData.uiStatusMapping,
      options: data.initializeData.options,
      relatedLocations: data.initializeData.relatedLocations,
      screenConfigs: data.initializeData.screenConfigs,
      userAuthType: data.initializeData.userAuthType
    }
  }),
  on(save_selected_companies, (state, data) => {
    return {
      ...state,
      selectedCompanies: data.selectedCompanies
    }
  }),
  on(update_password_auto_generated, (state, data) => {
    return {
      ...state,
      user: { ...state.user, passwordAutoGenerated: data.val }
    }
  }),
  on(clear_initialize_data, (state, data) => {
    return {
      ...initialInitializeState,
      taskTypes: null
    }
  })
)
